import { useQuery } from '@tanstack/react-query';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getBlockedInstPageIds = (): Promise<{ pageIds: string[] }> => {
  return axios.get('/meta/pages/blocked');
};

type QueryFnType = typeof getBlockedInstPageIds;

type UseGetBlockedInstPageIdsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetBlockedInstPageIds = ({ config = {} }: UseGetBlockedInstPageIdsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['instagram-blocked-pages'],
    queryFn: getBlockedInstPageIds,
  });
};
